import { Language } from 'store/slices/language-slice';

interface NotFoundMessages {
  error: {
    errorHeading: string;
    supportMessagePreLink: string;
    buttonText: string;
  };
}

type Message = {
  [key in Language]: NotFoundMessages;
};

const messages: Message = {
  en: {
    error: {
      errorHeading: 'Something Went Wrong',
      buttonText: 'Portfolio',
      supportMessagePreLink: 'Try again. If the problem continues, email us at',
    },
  },
};

export default messages;
